import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PartnerSessionMaxWatcher from '../admin-shared/PartnerSessionMaxWatcher';
import PartnerSessionTimeoutModal from '../admin-shared/PartnerSessionTimeoutModal';
import TrialPopup from './components/TrialPopup';
import ModernAlertHost from './components/ModernAlertHost';
import AppModal from './components/AppModal';
import { TrialProvider } from './context/TrialContext';
import { UserProvider } from './context/UserContext';
import { installNaturalsPortalFetchInterceptor } from '../admin-shared/patchPortalFetch';
import { API_BASE, PORTAL_ID, clearPortalStorage } from './utils/api';
import { applyThemeToDocument, getStoredTheme } from './utils/theme';

import './assets/fonts/local-fonts.css';
import './index.css';

export default function SalonAdminFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
  }, []);

  useEffect(() => installNaturalsPortalFetchInterceptor(PORTAL_ID, API_BASE), []);

  return (
    <UserProvider>
      <TrialProvider>
        <PartnerSessionMaxWatcher portalId={PORTAL_ID} loginPathPrefix="/naturals/login" />
        <PartnerSessionTimeoutModal
          AppModal={AppModal}
          clearPortalStorage={clearPortalStorage}
          loginPath="/naturals/login"
          portalId={PORTAL_ID}
        />
        <TrialPopup />
        <ModernAlertHost />
        <Outlet />
      </TrialProvider>
    </UserProvider>
  );
}
